// extracted by mini-css-extract-plugin
export var component = "previous-projects-module--component--yhhD7";
export var container = "previous-projects-module--container--357Aw";
export var description = "previous-projects-module--description--9SKN2";
export var image = "previous-projects-module--image--oqiWd";
export var media = "previous-projects-module--media--7QJZq";
export var meta = "previous-projects-module--meta--ZqKiP";
export var metaLabel = "previous-projects-module--metaLabel--u2Mso";
export var metaValue = "previous-projects-module--metaValue--EfcS4";
export var more = "previous-projects-module--more--JZkDC";
export var multiplayer = "previous-projects-module--multiplayer--ldu7j";
export var name = "previous-projects-module--name--DVdiR";
export var project = "previous-projects-module--project--9JsBi";
export var projectLink = "previous-projects-module--projectLink--3xZsl";
export var projects = "previous-projects-module--projects--e0zLO";
export var split = "previous-projects-module--split--IO2++";
export var splitHr = "previous-projects-module--splitHr--D8x+I";
export var splitTitle = "previous-projects-module--splitTitle--7m4Av";
export var tag = "previous-projects-module--tag--6TSCO";
export var website = "previous-projects-module--website--Uob0o";